import { Button, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { useEnrollments } from "utils/hooks/useEnrollments"

import CardBgAdornment from "./assets/CardBgAdornment.webp"
import styles from "./SuraasaCertificateCard.module.css"

const CertificateCardComponent = ({
  learningItemType,
  serialNumber,
  slug,
  logo,
}: {
  learningItemType: string
  serialNumber: string | undefined | null
  slug: string
  logo: string
}) => {
  const hasCertificate = !!serialNumber
  const { enrollments } = useEnrollments()
  const currentCourse = enrollments?.find(item => item.slug === slug)

  return (
    <div
      className={clsx(
        styles.root,
        "relative z-10 my-3 overflow-hidden rounded-2xl p-3",
        {
          [styles.hoverAnimation]: hasCertificate,
        }
      )}
    >
      {hasCertificate && (
        <img
          id="rings"
          src={CardBgAdornment}
          alt="bg"
          className={clsx(
            styles.rotate,
            "absolute bottom-px right-0 -z-10 h-full"
          )}
        />
      )}
      <img src={logo} alt="suraasa" className="mb-2 sm:mb-1" />
      <span className={clsx("block", styles.gradientText)}>
        {currentCourse?.name}
      </span>
      {hasCertificate ? (
        <Button className={clsx("mt-1.5", styles.viewBtn)} size="sm">
          View Certificate
        </Button>
      ) : (
        <Typography variant="smallBody" className="mt-1.5 text-white">
          You will earn this Certificate automatically after you finish this{" "}
          {learningItemType}
        </Typography>
      )}
    </div>
  )
}

export default CertificateCardComponent
